module.exports = "/images/6569c91ae370912df979eac30a713936.png";